import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/svgs/icon_change.svg';
const _hoisted_1 = {
  class: "area-info"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "area-info-divider"
}, null, -1);

const _hoisted_3 = {
  class: "area-info-text"
};
const _hoisted_4 = {
  class: "org-name"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "area-info-action-icon",
  src: _imports_0
}, null, -1);

const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "area-info-action-text"
}, " 切换 ", -1);

const _hoisted_7 = [_hoisted_5, _hoisted_6];

const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "area-info-divider"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_picker = _resolveComponent("van-picker");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("p", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.myOrgAndArea.orgName) + _toDisplayString(_ctx.myOrgAndArea.areaName ? ': ' : ''), 1), _createElementVNode("span", {
    class: _normalizeClass(_ctx.myOrgAndArea.areaName ? 'sc666' : '')
  }, _toDisplayString(_ctx.myOrgAndArea.areaName), 3)]), _createElementVNode("div", {
    class: "area-info-action",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.showAreaChangePicker = true)
  }, _hoisted_7), _hoisted_8, _createVNode(_component_van_popup, {
    show: _ctx.showAreaChangePicker,
    position: "bottom",
    round: "",
    "safe-area-inset-bottom": true,
    teleport: "body"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      ref: "picker",
      title: "请选择",
      "columns-field-names": _ctx.customFieldName,
      columns: _ctx.orgs,
      onConfirm: _ctx.onConfirm,
      onCancel: _cache[1] || (_cache[1] = $event => _ctx.showAreaChangePicker = false)
    }, null, 8, ["columns-field-names", "columns", "onConfirm"])]),
    _: 1
  }, 8, ["show"])]);
}